import { Link } from "@/lib/router-compat";
import { useTranslation } from "react-i18next";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { NAV_GROUPS } from "@/lib/navigation";
import { uiText } from "@/lib/i18n/uiText";

/**
 * Desktop mega-menu (hidden below lg). Driven entirely by NAV_GROUPS so every
 * route is reachable from the top bar — a comprehensive, crawlable surface for
 * search engines and AI agents. Group labels and item titles are localized via
 * the translation dictionary (falling back to the English source string).
 */
export function TopNav() {
  const { t } = useTranslation();
  return (
    <NavigationMenu className="hidden 2xl:flex">
      <NavigationMenuList className="gap-0">
        {NAV_GROUPS.map((group) => (
          <NavigationMenuItem key={group.label}>
            <NavigationMenuTrigger className="h-9 bg-transparent px-2.5 text-[13px] font-medium xl:px-3 xl:text-sm">
              {uiText(group.label)}
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[520px] grid-cols-2 gap-1 p-3">
                {group.items.map((item) => (
                  <li key={`${group.label}-${item.url}-${item.title}`}>
                    <NavigationMenuLink asChild>
                      <Link
                        to={item.url}
                        className={cn(
                          "block select-none rounded-md p-3 leading-none no-underline outline-hidden transition-colors",
                          "hover:bg-accent hover:text-accent-foreground focus:bg-accent",
                        )}
                      >
                        <div className="flex items-center gap-2 text-sm font-medium">
                          <span className="truncate">{uiText(item.title)}</span>
                        </div>
                        {item.description && (
                          <p className="mt-1 line-clamp-1 text-xs text-muted-foreground">
                            {uiText(item.description)}
                          </p>
                        )}
                      </Link>
                    </NavigationMenuLink>
                  </li>
                ))}
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
